let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("63tx1")).then(() => parcelRequire('bWYJ2'));